module.exports = __webpack_public_path__ + "static/media/siqLogo.9aab19e3.png";